import AxiosClient from "../../../services/axios.services";

class FoulTypeServices {
  getFoulType = (params) =>
    AxiosClient.get(
      "/api/app/sanciones_nivel_gravedad/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveFoulType = (data) =>
    AxiosClient.post(
      "/api/app/sanciones_nivel_gravedad/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editFoulType = (id, data) =>
    AxiosClient.put(
      `/api/app/sanciones_nivel_gravedad/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteFoulType = (id) =>
    AxiosClient.delete(
      `/api/app/sanciones_nivel_gravedad/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new FoulTypeServices();
